import React from "react";
import Typography from "@mui/joy/Typography";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { MdMail } from "react-icons/md";
import { Divider } from "@mui/material";
import { IconButton } from "@mui/material";
import info from "../content/info.json";

const Footer = () => (
  <footer
    style={{
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      padding: "20px",
    }}
  >
    <Divider style={{ width: "75%" }} />
    <div style={{ margin: "20px" }}>
      <IconButton
        size="small"
        component="a"
        href={info.socials.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          margin: "0 10px",
        }}
      >
        <FaLinkedin />
      </IconButton>
      <IconButton
        size="small"
        component="a"
        href={info.socials.instagram}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          margin: "0 10px",
        }}
      >
        <FaInstagram />
      </IconButton>
      <IconButton
        size="small"
        component="a"
        href={info.socials.email}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          margin: "0 10px",
        }}
      >
        <MdMail />
      </IconButton>
    </div>
    <Typography level="body-xs" textColor="text.tertiary">
      &copy; {new Date().getFullYear()} Rafael Gould-Schultz. All rights
      reserved.
    </Typography>
  </footer>
);

export default Footer;
